import type { PermitRow } from '@mollusk/shared';
import type { ReactNode } from 'react';
import { QueryErrorAlert, type QueryErrorMessages } from '../../components/QueryErrorAlert';
import { PermitsTable } from './PermitsTable';

interface Props extends QueryErrorMessages {
  result: {
    data: { permits: PermitRow[] } | undefined;
    error: unknown;
    isFetching: boolean;
  };
  loading: ReactNode;
  showAddress?: boolean;
}

/**
 * A permits query's table, error or loading state. A failed refetch keeps showing
 * the permits already loaded; a query that hasn't started yet shows `loading`.
 */
export function PermitsResult({ result, loading, showAddress = false, ...messages }: Props) {
  const { data, error, isFetching } = result;
  if (isFetching) return loading;
  if (data) return <PermitsTable permits={data.permits} showAddress={showAddress} />;
  if (error) return <QueryErrorAlert error={error} {...messages} />;
  return loading;
}
